(ns hai.ui.components.page
  (:require
   [hai.ui.components :as c]
   [lambdaisland.ornament :as o]))

(o/defstyled heading :div
  [:.section
   :flex :flex-row
   :items-center
   :mb-1 :mt-1]
  [:h1 :inline :mr-auto]
  ([{:keys [text]} & children]
   (into [:div.section
          [c/Heading {:size "5"} text]]
         children)))
